/* @flow */

import classNames from 'classnames';
import { compose } from 'ramda';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import styles from './LinkWithChevron.style';

import BaseLink from './BaseLink';
import ChevronIcon from 'src/shared/ui/component/icon/ChevronIcon';
import useEventAccentColor from 'src/shared/domain/event/hook/useEventAccentColor';

type Props = {
  href: string,
  children: React.Node,
  layoutClass?: string,
  handleClick?: () => void,
  handleMouseOver?: () => void,
  inNewWindow?: boolean,
};

const useStyles = createUseStyles(styles);

const LinkWithChevron = ({
  href,
  children,
  layoutClass,
  handleClick,
  handleMouseOver,
  inNewWindow,
}: Props): React.Node => {
  /*
   |------------------------------------------------------------------------------
   | Hooks
   |------------------------------------------------------------------------------
   */

  const [accentColor] = useEventAccentColor();

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles({ accentColor });

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  const rootClasses = classNames(classes.root, layoutClass);

  return (
    <BaseLink
      className={rootClasses}
      href={href}
      handleClick={handleClick}
      handleMouseOver={handleMouseOver}
      newWindow={inNewWindow}
    >
      {children}
      &nbsp;
      <span className={classes.icon}>
        <ChevronIcon right />
      </span>
    </BaseLink>
  );
};

export default compose(React.memo)(LinkWithChevron);
